import { HSpacer } from '@nx-smartmonkey/ui';
import { StyledFooterButton } from '../../../../../components/StyledFooterButton';
import { intl } from '../../../../../helpers/IntGlobalProvider';

import NorthStarIcon from '../../../../../assets/svg/NorthStarIcon';

interface RouteFooterProps {
  onClick: () => void;
  isLoading?: boolean;
  intlId: string;
}

export const RouteFooter = ({ onClick: OnClick, isLoading, intlId }: RouteFooterProps) => {
  return (
    <StyledFooterButton isLoading={isLoading} onClick={() => OnClick()}>
      {intl.formatMessage({ id: intlId })}
      <HSpacer small />
      <NorthStarIcon height="15px" width="15px" style={{ paddingRight: `8px` }} />
    </StyledFooterButton>
  );
};
